import React from 'react';
import { useParams } from 'react-router-dom';
import RealtimeParkingView from '../views/RealtimeParkingView';

const RealtimeParkingViewWrapper: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();

  return (
    <RealtimeParkingView
      project={{
        id: projectId || '',
        name: 'Current Project',
        description: 'Current working project',
        location: 'Seoul'
      }}
      onBack={() => window.history.back()}
    />
  );
};

export default RealtimeParkingViewWrapper;